/* CUSTOM KIYO START — kiyo-lp-details.js (2026-09-30)
   Tabs of sections/kiyo-lp-details.liquid (click, arrow keys, active chip scrolled into view on the phone),
   the colour toggles that swap the tab photo (and its product link) and the tab video, which plays only while its tab is open
   and the section is in view.
   07.10.: Home/End on the tabs; video posters load only for the open tab once the section is about a screen away;
   the height of the tab row is mirrored to --kld-tabs-h (from 1200 px the chips may wrap into a second row). */
(function () {
  var GROSS = window.matchMedia('(min-width: 990px)');

  function setPosters(root) {
    if (root.getAttribute('data-kld-near') !== '1') return;
    root.querySelectorAll('video[data-kld-poster]').forEach(function (video) {
      var panel = video.closest('[data-kld-panel]');
      if (!panel || panel.hidden) return;
      video.poster = (GROSS.matches && video.getAttribute('data-kld-poster-gross')) || video.getAttribute('data-kld-poster');
      video.removeAttribute('data-kld-poster');
      video.removeAttribute('data-kld-poster-gross');
    });
  }

  function syncVideos(root) {
    var inView = root.getAttribute('data-kld-in-view') === '1';
    root.querySelectorAll('[data-kld-video]').forEach(function (video) {
      var panel = video.closest('[data-kld-panel]');
      if (inView && panel && !panel.hidden) {
        if (video.preload !== 'auto') video.preload = 'auto';
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      } else if (!video.paused) {
        video.pause();
      }
    });
  }

  function activate(root, index) {
    root.querySelectorAll('[data-kld-tab]').forEach(function (btn) {
      var on = btn.getAttribute('data-kld-tab') === index;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-selected', on ? 'true' : 'false');
      btn.setAttribute('tabindex', on ? '0' : '-1');
    });
    root.querySelectorAll('[data-kld-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-kld-panel') !== index;
    });
    // A tab only opens on interaction, the section is on screen then
    root.setAttribute('data-kld-near', '1');
    setPosters(root);
    syncVideos(root);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-kld-tab]');
    if (!btn) return;
    var root = btn.closest('[data-kld]');
    if (!root) return;
    activate(root, btn.getAttribute('data-kld-tab'));
    var row = btn.parentNode;
    if (row.scrollWidth > row.clientWidth) {
      row.scrollTo({ left: btn.offsetLeft - (row.clientWidth - btn.offsetWidth) / 2, behavior: 'smooth' });
    }
  });

  // Colour toggles: show the detail photo in that colour
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-kld-farbe]');
    if (!btn) return;
    var panel = btn.closest('[data-kld-panel]');
    if (!panel) return;
    panel.querySelectorAll('[data-kld-farbe]').forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var link = panel.querySelector('[data-kld-link]');
    var href = btn.getAttribute('data-kld-href');
    if (link && href) link.href = href;
    var img = panel.querySelector('img.kld__bild');
    var url = btn.getAttribute('data-kld-src');
    if (!img || !url) return;
    var widths = (img.getAttribute('srcset') || '').split(',').map(function (c) {
      return parseInt((c.trim().split(/\s+/)[1] || ''), 10);
    }).filter(function (n) { return n > 0; });
    if (widths.length) {
      img.srcset = widths.map(function (n) { return url.replace(/([?&])width=\d+/, '$1width=' + n) + ' ' + n + 'w'; }).join(', ');
    }
    img.src = url;
    img.alt = btn.getAttribute('data-kld-alt') || img.alt;
  });

  document.addEventListener('keydown', function (event) {
    var key = event.key;
    if (key !== 'ArrowRight' && key !== 'ArrowLeft' && key !== 'Home' && key !== 'End') return;
    var btn = event.target.closest && event.target.closest('[data-kld-tab]');
    if (!btn) return;
    var tabs = Array.prototype.slice.call(btn.parentNode.querySelectorAll('[data-kld-tab]'));
    var i = tabs.indexOf(btn);
    var next = key === 'Home' ? 0 : key === 'End' ? tabs.length - 1 : i + (key === 'ArrowRight' ? 1 : -1);
    if (next < 0 || next >= tabs.length) return;
    event.preventDefault();
    if (next === i) return;
    tabs[next].focus();
    tabs[next].click();
  });

  // Theme editor: selecting a block inside a hidden tab opens that tab
  document.addEventListener('shopify:block:select', function (event) {
    var panel = event.target.closest && event.target.closest('[data-kld-panel]');
    var root = panel && panel.closest('[data-kld]');
    if (root) activate(root, panel.getAttribute('data-kld-panel'));
  });

  function init(root) {
    if (root.hasAttribute('data-kld-ready')) return;
    root.setAttribute('data-kld-ready', '');
    if ('IntersectionObserver' in window) {
      var near = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        root.setAttribute('data-kld-near', '1');
        setPosters(root);
        near.disconnect();
      }, { rootMargin: '100% 0px' });
      near.observe(root);
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          root.setAttribute('data-kld-in-view', e.isIntersecting ? '1' : '0');
          syncVideos(root);
        });
      }, { rootMargin: '100px 0px' }).observe(root);
    } else {
      root.setAttribute('data-kld-near', '1');
      root.setAttribute('data-kld-in-view', '1');
      setPosters(root);
    }
    // Height of the tab row for the content offset in the desktop layout (CSS falls back to one row = 48 px)
    var tabs = root.querySelector('.kld__tabs');
    if (tabs && 'ResizeObserver' in window) {
      new ResizeObserver(function () {
        root.style.setProperty('--kld-tabs-h', tabs.offsetHeight + 'px');
      }).observe(tabs);
    }
  }

  function initAll() { document.querySelectorAll('[data-kld]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
/* CUSTOM KIYO END */
